<template>
  <div class="admin-topbar d-flex align-items-center justify-content-between px-lg-4 px-3 py-3">
    <div>
      <div class="text-muted small text-uppercase font-weight-bold">Nihon Water Maintenance</div>
      <h1 class="h4 mb-0 font-weight-bold text-primary">CMS quản trị nội dung</h1>
    </div>
    <div class="d-flex align-items-center">
      <b-button :to="{ name: 'home' }" tag="router-link" variant="outline-primary" pill class="mr-2">
        Về trang chủ
      </b-button>
      <b-button variant="outline-primary" pill @click="logout">Đăng xuất</b-button>
    </div>
  </div>
</template>

<script>
import { clearAuth } from "../utils/auth";

export default {
  name: "AdminTopbar",
  methods: {
    logout() {
      clearAuth();
      this.$router.push({ name: "admin-login" });
    }
  }
};
</script>

<style scoped>
.admin-topbar {
  border-bottom: 1px solid rgba(0, 61, 153, 0.08);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(12px);
}
</style>

